export interface CguSection {
  title: string;
  content: string;
}

export const CGU_VERSION = '2026-02-08-v1';

export const CGU_SECTIONS: CguSection[] = [
  {
    title: '1. Introduction',
    content:
      "Les présentes Conditions Générales d'Utilisation et de Vente (CGU/CGV) s'appliquent au site web, aux appareils et aux services TrackFleet.lu, exploités par IT-secure Luxembourg SARL. En vous inscrivant sur ce site, en y accédant ou en l'utilisant de toute autre manière, vous acceptez d'être lié par les conditions énoncées ci-dessous. Des contrats supplémentaires peuvent exister et prévalent en cas de conflit avec les présentes conditions.",
  },
  {
    title: '2. Acceptation obligatoire',
    content:
      "En vous inscrivant sur ce site, en y accédant ou en l'utilisant de toute autre manière, vous acceptez par les présentes d'être lié par les conditions énoncées dans les présentes Conditions Générales d'Utilisation et de Vente, y compris les conditions et politiques supplémentaires référencées dans les présentes et/ou disponibles par lien hypertexte.",
  },
  {
    title: '3. Communication électronique',
    content:
      "En utilisant le site, vous acceptez de recevoir des communications électroniques. Vous reconnaissez que tous les accords, notifications, publications et autres communications que nous vous fournissons par voie électronique répondent à toute exigence légale, y compris l'exigence que ces communications soient écrites.",
  },
  {
    title: '4. Propriété intellectuelle',
    content:
      "La société ou ses licenciés possèdent tous les droits d'auteur et de propriété intellectuelle relatifs au site et à son contenu. Aucune licence ni aucun autre droit ne vous est accordé en vertu des droits d'auteur, des marques, des brevets ou d'autres droits de propriété intellectuelle de la société ou d'un tiers, sauf indication contraire expresse dans les présentes conditions.",
  },
  {
    title: '5. Propriété de tierce partie',
    content:
      "Le site peut contenir des liens vers des sites web tiers. Nous ne sommes pas responsables des pratiques de confidentialité ou du contenu de ces sites. L'utilisation de ces liens se fait à vos propres risques.",
  },
  {
    title: '6. Utilisation responsable',
    content:
      "Il est strictement interdit d'utiliser le site pour : distribuer des logiciels malveillants, effectuer du marketing direct non autorisé, collecter de manière systématique des données sans consentement, ou mener toute activité causant des dommages au site ou à ses utilisateurs.",
  },
  {
    title: '7. Inscription',
    content:
      "Les utilisateurs sont responsables de la confidentialité de leurs mots de passe et de toutes les activités qui se produisent par l'utilisation de leurs mots de passe ou comptes. Vous vous engagez à nous notifier immédiatement toute utilisation non autorisée de votre compte.",
  },
  {
    title: '8. Politique de remboursement et de retour',
    content:
      "8.1 Droit de rétractation : Vous avez le droit de résilier ce contrat dans les 14 jours sans donner de raison. Le délai de rétractation commence à la réception physique des marchandises.\n\n8.2 Effets de la rétractation : En cas de rétractation, nous vous rembourserons intégralement dans les 14 jours, à l'exception des frais de livraison non-standard. Le retour des marchandises est obligatoire dans le même délai.",
  },
  {
    title: "9. Soumission d'idée",
    content:
      "En l'absence d'accord préalable, toute soumission d'idée accorde à la société une licence mondiale, irrévocable, non exclusive et libre de redevance pour utiliser, reproduire, modifier et distribuer le contenu soumis.",
  },
  {
    title: "10. Fin de l'utilisation",
    content:
      "Nous pouvons, à notre seule discrétion, à tout moment modifier ou interrompre l'accès au site, temporairement ou définitivement, avec ou sans préavis.",
  },
  {
    title: '11. Garanties et responsabilité',
    content:
      "Le site est fourni \"en l'état\" et \"selon disponibilité\". Aucune garantie n'est donnée concernant la disponibilité, l'exactitude ou l'exhaustivité du contenu. La responsabilité de la société est limitée au montant payé par l'utilisateur pour les services concernés.",
  },
  {
    title: '12. Confidentialité',
    content:
      "Les données personnelles sont protégées conformément à notre Politique de Confidentialité. Nous n'utiliserons pas votre adresse e-mail pour du courrier non sollicité. Tout e-mail envoyé par nous sera en rapport avec les services fournis.",
  },
  {
    title: "13. Restrictions à l'exportation / Conformité juridique",
    content:
      "L'accès au site est interdit depuis les territoires où le contenu est considéré comme illégal. Vous êtes tenu de vous conformer aux lois luxembourgeoises et à toutes les lois applicables en matière d'exportation et de sanctions.",
  },
  {
    title: "14. Marketing d'affiliation",
    content:
      "La société peut recevoir des commissions ou des parrainages, conformément au Code de la consommation applicable. Toute relation d'affiliation sera divulguée de manière transparente.",
  },
  {
    title: '15. Affectation',
    content:
      "Vous ne pouvez céder, transférer ou sous-traiter aucun de vos droits et/ou obligations en vertu des présentes conditions sans notre consentement écrit préalable.",
  },
  {
    title: '16. Violation des présentes conditions générales',
    content:
      "La société se réserve le droit de suspendre ou de révoquer l'accès au site et/ou d'engager des poursuites en cas de violation des présentes conditions ou de tout comportement préjudiciable aux intérêts de la société.",
  },
  {
    title: '17. Indemnisation',
    content:
      "Vous acceptez d'indemniser et de dégager de toute responsabilité la société, ses dirigeants, employés et agents contre toute réclamation, perte, dommage ou dépense (y compris les frais d'avocat) découlant de votre violation des présentes conditions ou des lois applicables.",
  },
  {
    title: '18. Dérogation',
    content:
      "Le fait de ne pas exercer ou de ne pas appliquer un droit ou une disposition des présentes conditions ne constitue pas une renonciation à ce droit ou à cette disposition.",
  },
  {
    title: '19. Langue',
    content:
      "Les présentes Conditions Générales d'Utilisation et de Vente sont rédigées exclusivement en français. En cas de traduction, la version française prévaudra.",
  },
  {
    title: '20. Accord intégral',
    content:
      "Les présentes Conditions Générales d'Utilisation et de Vente, conjointement avec notre Politique de Confidentialité et notre Politique de Cookies, constituent l'accord complet entre vous et la société concernant l'utilisation du site et des services.",
  },
  {
    title: '21. Mise à jour des présentes conditions générales',
    content:
      "La société se réserve le droit de mettre à jour les présentes conditions à tout moment. Les utilisateurs seront informés de toute modification significative. L'utilisation continue du site après modification constitue acceptation des nouvelles conditions.",
  },
  {
    title: '22. Choix de la loi et de la juridiction',
    content:
      "Les présentes conditions sont régies par les lois du Grand-Duché de Luxembourg. Tout litige sera soumis à la juridiction exclusive des tribunaux luxembourgeois.",
  },
  {
    title: '23. Information de contact',
    content:
      "Propriétaire : IT-secure Luxembourg SARL\nEmail : contact@it-secure.lu\nAdresse : 210 avenue de Luxembourg, L-4940 Bascharage, Grand-Duché de Luxembourg",
  },
  {
    title: '24. Téléchargement',
    content:
      "Une version PDF téléchargeable des présentes conditions est disponible sur demande.",
  },
];

export const PRIVACY_SECTIONS: CguSection[] = [
  {
    title: '1. Collecte et traitement des données personnelles',
    content:
      "Le propriétaire et le contrôleur du fichier automatisé est IT-secure Luxembourg SARL, propriétaire de TrackFleet.lu, avec siège social au 210, avenue de Luxembourg L-4940 Bascharage, Grand-Duché de Luxembourg.\n\nL'hébergement est réalisé par OVH S.A., basée à Roubaix, France.\n\nVos données personnelles sont utilisées aux fins suivantes :\n- Gestion des commandes et des inscriptions\n- Garantir le bon fonctionnement de la plateforme\n- Répondre à vos questions et demandes de support\n- Informations sur les offres et promotions (avec consentement)\n- Création et gestion de votre profil utilisateur\n\nLa base juridique du traitement de vos données est le consentement éclairé et l'exécution du contrat de service.",
  },
  {
    title: '2. Destinataires des données',
    content:
      "Les données personnelles ne seront pas fournies à des tiers sauf obligation légale ou dans le cadre strict des finalités décrites (administrations publiques si nécessaire, prestataires de paiement).",
  },
  {
    title: '3. Vos droits',
    content:
      "Vous disposez des droits suivants concernant vos données personnelles :\n- Droit d'accès : obtenir la confirmation que TrackFleet.lu traite ou non vos données\n- Droit de rectification : demander la correction de données inexactes\n- Droit à l'effacement : demander la suppression de vos données\n- Droit à la limitation du traitement\n- Droit d'opposition pour des raisons liées à votre situation particulière\n- Droit à la portabilité des données\n\nÀ tout moment, vous pouvez déposer une réclamation auprès de l'autorité de contrôle compétente.\n\nPour exercer vos droits : contact@it-secure.lu",
  },
  {
    title: '4. Sécurité des données',
    content:
      "Toutes les informations confidentielles envoyées via notre site Web sont cryptées via protocole SSL. Les données pouvant relier l'identification du moyen de paiement à l'identité de l'utilisateur ne sont pas stockées sur nos serveurs.",
  },
  {
    title: '5. Passerelle de paiement',
    content:
      "Tout paiement ou transaction économique effectué via le site Web utilise un système de passerelle de paiement sécurisé. TrackFleet.lu n'a aucun accès aux données de carte de crédit, celles-ci étant saisies directement sur le site sécurisé de la banque.",
  },
  {
    title: '6. Cookies et technologies de suivi',
    content:
      "Nous utilisons des cookies et des technologies de suivi similaires pour suivre l'activité sur notre service. Les types de cookies utilisés comprennent :\n- Cookies de session (fonctionnement du site)\n- Cookies de préférence (vos paramètres)\n- Cookies de sécurité (protection de votre compte)\n\nVous pouvez configurer votre navigateur pour refuser les cookies.",
  },
  {
    title: '7. Modification de la politique de confidentialité',
    content:
      "TrackFleet.lu peut modifier ou mettre à jour la présente politique de confidentialité à tout moment, conformément aux évolutions légales et réglementaires. Si vous n'êtes pas d'accord avec les modifications, il est recommandé de cesser l'utilisation du site.",
  },
  {
    title: '8. Contact',
    content:
      "IT-secure Luxembourg SARL\nSiège social : 210, avenue de Luxembourg L-4940 Bascharage (GDL)\nTéléphone : +352 20 600 232\nEmail : contact@it-secure.lu\nHoraires : 8h00 - 17h00",
  },
];
